import React from "react";
import styles from "./LessonNavigationControls.module.css";
import {Button} from "../Button/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPause, faPlay, faStepBackward, faStepForward} from "@fortawesome/free-solid-svg-icons";
import {useLessonNavigation} from "../../hooks/useLessonNavigation";
import {useLessonPlaybackState} from "../../hooks/useLessonPlaybackState";

export const LessonNavigationControls = () => {

    const { next, back, sectionIndex, subSectionIndex } = useLessonNavigation();
    const { state, togglePlayback } = useLessonPlaybackState();

    const onPlayClick = () => {
        try {
            togglePlayback();
        } catch (error) {
            console.error('Erro ao carregar o áudio:', error.message);
        }
    }

    return (
        <div className={styles.container}>

            <Button onClick={back} className={styles.navigationButton} enabled={sectionIndex > 0 || subSectionIndex > 0}>
                <FontAwesomeIcon icon={faStepBackward}/>
            </Button>

            <div className={styles.iconPlayContainer}>
                <Button onClick={() => onPlayClick()} className={styles.navigationButton} >

                    {state === 'playing' ? (
                        <FontAwesomeIcon icon={faPause}/>
                    ) : (
                        <FontAwesomeIcon icon={faPlay}/>
                    )}

                </Button>
            </div>

            <Button onClick={next} className={styles.navigationButton}>
                <FontAwesomeIcon icon={faStepForward}/>
            </Button>

        </div>
    );
}
